export enum ProfileComponentBody {
  PUBLISHED_ASSIGNMENT_BODY = 'PublishedAssignmentProfile',
  HORIZONTAL_PROFILE_BODY = 'HorizontalProfile',
  PENDING_ASSIGNMENTS_BODY = 'PendingAssignmentProfile',
}
